import SFetch from '@app/utils/sfetch'

export function followCompany(): Promise<void | Response | null> {
  const url = window.Silverfin.Routes.follow_company_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    { company_id: window.Silverfin.currentCompanyId }
  )

  return SFetch.json(url, { method: 'POST' })
}

export function unfollowCompany(): Promise<void | Response | null> {
  const url = window.Silverfin.Routes.unfollow_company_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    { company_id: window.Silverfin.currentCompanyId }
  )

  return SFetch.json(url, { method: 'POST' })
}
